import { render, staticRenderFns } from "./ShopMobile.vue?vue&type=template&id=29d2a3ab"
import script from "./ShopMobile.vue?vue&type=script&lang=js"
export * from "./ShopMobile.vue?vue&type=script&lang=js"
import style0 from "./ShopMobile.vue?vue&type=style&index=0&id=29d2a3ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports